import styled from 'styled-components/macro'
import { COLORS } from '../../constants'
export const HeroDiv = styled.div`
  padding: 5rem 0;
  width: 100%;
  @media screen and (max-width: 768px) {
    padding: 3.5rem 0;
  }
`

export const HeroTextDiv = styled.div`
  padding: 0.5rem 12rem;
  justify-content: flex-start;
  font-family: 'Lexend', sans-serif;
  @media screen and (max-width: 768px) {
    padding: 0.5rem 2rem;
    text-align: left;
  }
`
export const HeroText = styled.h5`
  font-family: 'Ubuntu', sans-serif;
  letter-spacing: 0.25rem;
  font-size: 5rem;
  color: white;

  @media screen and (max-width: 768px) {
    font-size: 2.25rem;
  }
`

export const HeroSubText = styled.h4`
  font-family: 'Lexend Exa', sans-serif;
  padding-top: 1rem;
  font-size: 2rem;
  font-weight: 200;
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
`

export const HeroSubTextDiv = styled.div`
  padding: 0.2rem 12rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media screen and (max-width: 768px) {
    padding: 0rem 2rem;
    text-align: left;
  }
`
export const HeroBtn = styled.div`
  cursor: pointer;
  background-color: ${COLORS.heroBtnBlue};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Lexend Exa', 'sans serif';
  margin-top: 1rem;
  border-radius: 5px;

  width: 10rem;
  height: 3.25rem;
  color: #f7f7f7;
  font-weight: bold;
  font-size: 1rem;
  text-decoration: none;
  transition: transform 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55),
    background-position 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55),
    box-shadow 500ms linear;
  background-size: contain;
  background-repeat: no-repeat;
  &:hover {
    transform: scale(1.1);
    background-position: -60px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }
  &:active {
    /* transform: scale(1); */
    background-position: 500px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }

  @media screen and (max-width: 768px) {
    width: 10rem;
    height: 3rem;
    font-size: 0.75rem;
  }
`
